import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type UserRole = "user" | "dev" | "admin";

export interface AuthUser {
  id: string;
  email: string;
  username: string;
  role: UserRole;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  setSession: (payload: {
    user: AuthUser;
    accessToken: string;
    refreshToken: string;
  }) => void;
  updateAccessToken: (token: string) => void;
  clearSession: () => void;
}

const initialState = {
  user: null as AuthUser | null,
  accessToken: null as string | null,
  refreshToken: null as string | null,
};

export const useAuthStore = create<AuthState>()(
  persist<AuthState>(
    set => ({
      ...initialState,
      setSession: (payload: {
        user: AuthUser;
        accessToken: string;
        refreshToken: string;
      }) =>
        set({
          user: payload.user,
          accessToken: payload.accessToken,
          refreshToken: payload.refreshToken,
        }),
      updateAccessToken: (token: string) =>
        set((state: AuthState) => ({
          ...state,
          accessToken: token,
        })),
      clearSession: () => set({ ...initialState }),
    }),
    {
      name: "epost-platform-auth-v2",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
